// extracted by mini-css-extract-plugin
export var businessTile = "business-partners-list-module--business-tile--tP3J+";
export var partnersWrapper = "business-partners-list-module--partners-wrapper--vwpQ8";